import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import SparkLine from 'components/molecules/charts/SparkLine';

class SparkLineContainer extends Component {
    render() {
        return (<SparkLine {...this.props} />);
    }
}

const mapStateToProps = state => ({
    backfillBuckets: get(state, 'config.timeBuckets.config.sparkline', [])
});

export default connect(mapStateToProps)(SparkLineContainer);



// WEBPACK FOOTER //
// ./src/containers/charts/SparkLineContainer.js